/**
 * Validation mixin for form handling
 */
var validationMixin = {
	data: {
		invalidFields: [],
		showStandardSizesOnly: false,
		showSocketCutouts: true,
		serverSideValidationPassed: false,
	},
	mounted() {
		const vm = this;
	},
	methods: {
		/**
		 * Clears error message fields
		 */
		clearErrors: function () {
			const vm = this;

			vm.inStock = true;

			const errorMessages = document.querySelectorAll("[id$='-error']");

			vm.clearServerSideErrors(errorMessages);

			const invalidFields = document.querySelectorAll('.is-invalid');

			if (invalidFields.length > 0) {
				invalidFields.forEach((invalidField) => {
					invalidField.classList.remove('is-invalid');
					invalidField.parentElement.classList.remove('is-invalid');
					invalidField.classList.remove('is-invalid-property');
					invalidField.parentElement.classList.remove('is-invalid-property');
				});
			}
		},
		/**
		 * Clear server side error messages
		 */
		clearServerSideErrors: function (errorMessages) {
			const vm = this;

			if (errorMessages.length > 0) {
				errorMessages.forEach((el) => {
					el.classList.add('d-none');
					el.classList.forEach((className) => {
						if (className.startsWith('error-')) {
							el.classList.remove(className);
						}
					});
				});
			}
		},
		/**
		 * Adds required attributes to elements based on their dataset.
		 * 
		 * Iterates over the component's refs and checks if each element has a 'required' dataset attribute set to 'True'.
		 * If so, sets the 'required' property of the element to true.
		 */
		addRequiredAttributes: function () {
			Object.keys(this.$refs).forEach((ref) => {
				const element = this.$refs[ref];
				if (element.dataset.required === 'True') {
					element.required = true;
				}
			});
		},
		/**
		 * Checks if all required fields in the form are valid.
		 *
		 * @returns {boolean} True if all required fields are valid, false otherwise.
		 */
		requiredFieldsAreValid: function () {
			const vm = this;
			const requiredAttributes = document.querySelectorAll(
				'#vueProduct select[required], #vueProduct input[required]'
			);

			vm.invalidFields = [];
			let letterRadios = false;

			let drilledHoles = false;
			let typefaceName = '';
			let drilledHoleName = '';
			let radiosSelected = false;
			let drilledSelected = false;
			requiredAttributes.forEach(function (el) {
				el.classList.remove('is-invalid');
				el.parentElement.classList.remove('is-invalid');

				if (el.type === 'number' && !Number(el.value)) {
					vm.invalidFields.push(el.id);
				}

				if (el.type === 'checkbox') {
					if (el.parentElement.parentElement.classList.contains('drill-hole-group')) {
						drilledHoles = true;
						drilledHoleName = el.name;
					}
				}

				if (el.type === 'radio') {
					if (el.parentElement.parentElement.classList.contains('typeface')) {
						letterRadios = true;
						typefaceName = el.name;
					}
				}

				if (el.type === 'select-one' && el.value === '0') {
					vm.invalidFields.push(el.id);
				}

				if (el.type === 'select-one' && el.id === 'type-of-plastic' && vm.product.materialId === 0) {
					vm.invalidFields.push(el.id);
				}

				if (el.id === 'standardSizes' && el.value === '0') {
					vm.invalidFields.push(el.id);
				}

				if (el.type === 'text' && el.id === 'select-color') {
					if (vm.isEmpty(vm.product.colour)) {
						vm.invalidFields.push(el.id);
					}
				} else if (el.type === 'text' && el.value.length === 0) {
					vm.invalidFields.push(el.id);
				}
			});

			if (letterRadios) {
				if (document.querySelector('input[name="' + typefaceName + '"]:checked')) {
					radiosSelected = true;
					document.querySelector('.selector-slider.typeface').classList.remove('is-invalid');
				} else {
					const letterRadioInputs = document.querySelectorAll('input[name="' + typefaceName + '"]');
					letterRadioInputs.forEach(function (radioInput) {
						vm.invalidFields.push(radioInput.id);
					});
					document.querySelector('.selector-slider.typeface').classList.add('is-invalid');
				}
			}

			if (drilledHoles) {
				if (document.querySelector('input[name="' + drilledHoleName + '"]:checked')) {
					drilledSelected = true;
					document.querySelector('.drill-box').classList.remove('is-invalid');
				} else {
					const drilledHoleInputs = document.querySelectorAll('input[name="' + drilledHoleName + '"]');
					drilledHoleInputs.forEach(function (holeInput) {
						vm.invalidFields.push(holeInput.id);
					});
					document.querySelector('.drill-box').classList.add('is-invalid');
				}
			}

			if (vm.invalidFields.length === 0) {
				return true;
			}

			vm.invalidFields.forEach(function (id, index) {
				let el = vm.getById(id);
				el.classList.add('is-invalid');

				if (el.parentElement.classList.contains('select-color')) {
					el.parentElement.parentElement.classList.add('is-invalid');
				} else {
					el.parentElement.classList.add('is-invalid');
				}

				//focus on first unless already focused in an input
				if (index === 0 && document.activeElement.nodeName != 'INPUT') {
					el.focus();
				}
			});

			return false;
		},
	},
};
